<template>
  <div class="password-find">
    <header-title></header-title>
    <div class="container">
      <div class="ft20 b prompt">找回密码</div>
      <div class="main-form">
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px">
          <el-form-item label="手机号：" prop="phone">
            <el-input placeholder="请输入您的手机号" v-model.number="ruleForm.phone" />
          </el-form-item>

          <div class="flex-right-auto">
            <el-form-item label="验证码：" prop="code" class="flex-right">
              <el-input placeholder="请输入验证码" v-model="ruleForm.code"></el-input>
            </el-form-item>
            <el-button
              :type="!showTime?'primary':'info'"
              :disabled="(showTime||(!testPhone))"
              @click="getCode()"
              class="get-code"
            >
              获取验证码
              <span v-show="showTime">{{count}}</span>
            </el-button>
          </div>

          <el-form-item label="新密码：" prop="newPassword">
            <el-input
              v-model="ruleForm.newPassword"
              type="password"
              placeholder="密码为6-18位，可用数字/字母/符号"
              @keyup.native.enter="submitForm('ruleForm')"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')" style="width:100%">提交</el-button>
          </el-form-item>
          <el-form-item class="tc">
            <router-link to="/login">
              <span class="blue">账号密码登录</span>
            </router-link>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderTitle from "@/components/header-title";

import { checkPhone, checkPassword } from "@/base/js/verification";

import { _sendCode, _changePasswordSave } from "@/api/password-find";

import qs from "qs";
import { mapMutations } from "vuex";
import loginMixins from "../login/loginMixins";

export default {
  mixins: [loginMixins],
  components: {
    "header-title": HeaderTitle
  },
  data() {
    checkPhone;
    checkPassword;
    return {
      //关于按钮定时器相关内容
      count: "",
      timer: null,
      showTime: false,
      //发送验证码后保存token和time
      code_info: {},
      //重置密码相关数据
      ruleForm: {
        phone: "",
        code: "",
        newPassword: ""
      },
      //验证相关数据
      rules: {
        phone: [{ validator: checkPhone, trigger: "blur", required: true }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        newPassword: [
          { validator: checkPassword, trigger: "blur", required: true },
          {
            min: 6,
            max: 16,
            message: "长度在 6 到 18 个字符，可用数字，字母符号",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    initLoginBoxHeight() {
      const Win_H = window.innerHeight;
      // header高60 el-main的padding为20
      const loginBox_H = `${Win_H - 60 - 20 - 20}px`;
      return loginBox_H;
    },
    testPhone() {
      const reg = /^1[0-9]{10}$/;
      return reg.test(this.ruleForm.phone);
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.changePasswordSave();
        } else {
          return false;
        }
      });
    },
    //获取验证码
    getCode() {
      //添加定时器实现样式和按钮禁止选择的效果
      this.showTime = true;
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            clearInterval(this.timer);
            this.timer = null;
            this.showTime = false;
          }
        }, 1000);
      }
      this.sendCode();
    },
    //添加修改密码发送验证码
    sendCode() {
      _sendCode({
        data: qs.stringify({
          mobile: Number(this.ruleForm.phone)
        })
      }).then(res => {
        if (res.resultCode == 1) {
          this.$message({
            message: res.errorMsg,
            type: "success"
          });
          this.code_info = res.result;
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    //确认修改密码并且登录
    changePasswordSave() {
      const data = {
        token: this.code_info.token,
        time: this.code_info.time,
        mobile: this.ruleForm.phone,
        password: this.ruleForm.newPassword,
        code: this.ruleForm.code
      };
      _changePasswordSave({ data: qs.stringify(data) }).then(res => {
        if (res.resultCode == 1) {
          this.$message({
            message: res.errorMsg,
            type: "success"
          });
          const loginData = {
            mobile: data.mobile,
            password: data.password
          };
          this.login(loginData);
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    ...mapMutations({
      updateUserInfo: "updateUserInfo"
    })
  }
};
</script>

<style lang="less" scoped>
.password-find {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .container {
    width: 600px;
    height: 380px;
    background: #fff;
    -webkit-box-shadow: #666 0px 0px 4px;
    -moz-box-shadow: #666 0px 0px 4px;
    box-shadow: #666 0px 0px 4px;
    .main-form {
      width: 500px;
      height: 200px;
      margin: 0 auto;
      margin-top: 40px;
    }
    .prompt {
      margin: 20px;
    }
  }
}

.get-code {
  margin-left: 30px;
}
</style>
